export enum ContactType {
  ENTERPRISE = "enterprise",
  STRUCTURE_PARTNER = "structurePartner",
}
